/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListProductsCatalogQueryResponse,
  ListProductsCatalogQueryParams,
} from '../types/ListProductsCatalog'

function getListProductsCatalogUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/products/catalog/products/` as const,
  }
  return res
}

/**
 * @description Get paginated products catalog.
 * Query Parameters:
 * - search: Search by product name
 * - type: Filter type for multi-select logic (one, all, neither)
 * - sort/ordering: Field to sort by (with optional - prefix for descending)
 * - page: Page number (default: 1)
 * - limit/page_size: Items per page (default: 50, max: 1000)
 * Range Filters (use _greater/_less suffixes):
 * - avg_serving_size_per_lb_greater/less: Filter by avg volume per unit
 * - mfg_avg_list_price_per_lb_greater/less: Filter by avg revenue per unit
 * - est_monthly_churn_rate_greater/less: Filter by churn rate
 * - estimated_sales_potential_greater/less: Filter by avg units sold per month
 * - variants_count_greater/less: Filter by number of variants
 * Date Range Filters (use _greater/_less suffixes):
 * - created_greater/less: Filter by creation date
 * - modified_greater/less: Filter by modification date
 * Returns:
 * {
 * "results": [...],
 * "count": total_count,
 * "page": page,
 * "page_size": page_size
 * }
 * @summary List products catalog
 * {@link /api/v1/products/catalog/products/}
 */
export async function listProductsCatalog(
  params?: ListProductsCatalogQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListProductsCatalogQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListProductsCatalogUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
